import { Component, Inject, OnInit } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

import { IVerifiableAddressContact } from 'v2/shared/contact/address.interface';

import { ISalesOrderShipment } from '../../../order';
import { IDimension, IWeight } from '../../../shared/interfaces/common.interface';

@Component({
  selector: 'lum-shipping-label',
  templateUrl: './shipping-label.component.html',
  styleUrls: ['./shipping-label.component.scss'],
})
export class ShippingLabelComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data :{
      shipTo :IVerifiableAddressContact;
      shipDate :string;
      salesOrderId :number;
      carrierCode :string;
      serviceCode :string;
      packageCode :string;
      weight :IWeight;
      dimensions :IDimension;
      confirmation :string;
      isBulkUpdate ?:boolean;
      appIntegrationAccountId ?:number;
      salesOrderShipmentId ?:number | null;
      hasMultipleShipments ?:boolean;
      salesOrderShipments ?:ISalesOrderShipment[];
    },
    private dialogRef :MatDialogRef<ShippingLabelComponent>,
  ) {}

  ngOnInit() :void {}

  onClose() :void {
    this.dialogRef.close();
  }

  onFormSubmitted(data :any) :void {
    this.dialogRef.close(data);
  }
}
